module.exports = __webpack_public_path__ + "img/sticker_text.282ade77.svg";